export default __webpack_public_path__ + "static/media/Screenshot_15.16b730b8.png";